import React, { useEffect, useState } from "react";
import {
    Box,
    MenuItem,
    Grid,
    TextField,
    Button,
} from "@mui/material";
import {
    makeGETRequestOnUserService,
    makePOSTRequestOnUserService,
    makePUTRequestOnUserService,
} from "../../Api/api";
import { QNA } from '../Users/RiskProfiling';

export const RiskProfile = ({ activeTab, currentUser, user_type, setValue, getErrorMessage }: any) => {
    const [riskProfileId, setRiskProfileId] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const toastr = require("toastr");

    const [form, setForm] = useState<any>({
        age: "",
        residentialStatus: "",
        investmentBackground: "",
        financialGoal: "",
        yourPreference: "",
        investmentHorizon: "",
    });

    const handleChange = (name: string, value: string) => {
        setForm((prev: any) => ({ ...prev, [name]: value }));
    };

    const fetchRiskProfile = async () => {
        try {
            setLoading(true);
            const res = await makeGETRequestOnUserService(
                `/partneruser/get_risk_profile/${user_type}/${currentUser.uuid}/`
            );
            const data = res?.data;
            if (data) {
                setForm({
                    age: data.age || "",
                    residentialStatus: data.residential_status || "",
                    investmentBackground: data.investment_background || "",
                    financialGoal: data.financial_goal || "",
                    yourPreference: data.preference || "",
                    investmentHorizon: data.investment_horizon || "",
                });

                setRiskProfileId(data.uuid || "exists");
            }
        } catch (err) {
            console.log("GET RISK PROFILE ERROR", err);
        } finally {
            setLoading(false);
        }
    };

    const buildPayload = () => {
        return {
            age: form.age || "",
            residential_status: form.residentialStatus || "",
            investment_background: form.investmentBackground || "",
            financial_goal: form.financialGoal || "",
            preference: form.yourPreference || "",
            investment_horizon: form.investmentHorizon || "",
        };
    };

    const createRiskProfile = async () => {
        try {
            setLoading(true);
            const payload = {
                user_type,
                user: currentUser.uuid,
                ...buildPayload(),
            };
            const resp = await makePOSTRequestOnUserService(
                `/partneruser/create_risk_profile/`,
                payload
            );

            if (resp.status === 200 || resp.status === 201) {
                toastr.success("Risk Profile Created");
                fetchRiskProfile();
                setValue((prev: number) => prev + 1);
            }
        } catch (err: any) {
            toastr.error(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    const updateRiskProfile = async () => {
        try {
            setLoading(true);

            const resp = await makePUTRequestOnUserService(
                `/partneruser/update_risk_profile/${user_type}/${currentUser.uuid}/`,
                buildPayload()
            );

            if (resp.status === 200) {
                toastr.success("Risk Profile Updated");
            }
        } catch (err: any) {
            toastr.error(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (
            activeTab === "kycRiskProfile" ||
            activeTab === "riskProfile"
        ) {
            fetchRiskProfile();
        }
    }, [activeTab, currentUser?.uuid, user_type]);

    return (
        <Box sx={{ p: 3 }}>
            <Grid container spacing={3}>
                {QNA.map((q) => (
                    <Grid item xs={6} key={q.name}>
                        <TextField
                            select
                            fullWidth
                            label={q.que}
                            value={form[q.name]}
                            onChange={(e) => handleChange(q.name, e.target.value)}
                            SelectProps={{ native: false }}
                        >
                            {q.ans.map((option: string) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                ))}

                <Grid item xs={12} textAlign="center">
                    {riskProfileId ? (
                        <Button
                            variant="contained"
                            onClick={updateRiskProfile}
                            disabled={loading}
                            sx={{
                                backgroundColor: "#262349",
                                "&:hover": { backgroundColor: "#1d1a3a" },
                            }}
                        >
                            {loading ? "Updating..." : "Update Risk Profile"}
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            onClick={createRiskProfile}
                            disabled={loading}
                            sx={{
                                backgroundColor: "#262349",
                                "&:hover": { backgroundColor: "#1d1a3a" },
                            }}
                        >
                            {loading ? "Creating..." : "Create Risk Profile"}
                        </Button>
                    )}
                </Grid>
            </Grid>
        </Box>
    );
};